import {Alert, Snackbar} from '@mui/material';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {useGetReadOnlyModeQuery} from '../../store/system/systemApi';
import {formatReadOnlyModeStartsAt} from '../../utils/readOnlyModeDateTime';
import {READ_ONLY_MODE_LOCKED_EVENT} from '../../utils/readOnlyModeEvents';

export default function ReadOnlyModeNotification() {
    const [lockedMessage, setLockedMessage] = useState('');
    const [dismissedStatus, setDismissedStatus] = useState('');
    const tokenFromStore = useSelector((state) => state.auth.token);
    const token = tokenFromStore || localStorage.getItem('token');
    const isAuthenticated = token && token !== 'null' && token !== 'undefined';
    const {data: readOnlyMode} = useGetReadOnlyModeQuery(undefined, {
        skip: !isAuthenticated,
        pollingInterval: 60000,
        refetchOnFocus: true,
    });

    useEffect(() => {
        const showLockedMessage = (event) => {
            setLockedMessage(event.detail || 'Операция недоступна в режиме «Только чтение»');
        };

        window.addEventListener(READ_ONLY_MODE_LOCKED_EVENT, showLockedMessage);
        return () => window.removeEventListener(READ_ONLY_MODE_LOCKED_EVENT, showLockedMessage);
    }, []);

    const statusKey = readOnlyMode?.startsAt
        ? `${readOnlyMode.startsAt}:${Boolean(readOnlyMode.enabled)}`
        : '';
    const statusMessage = readOnlyMode?.enabled
        ? 'Система временно работает в режиме «Только чтение»'
        : readOnlyMode?.warningRequired && readOnlyMode?.startsAt
            ? `Система будет временно переведена в режим «Только чтение» ${formatReadOnlyModeStartsAt(readOnlyMode.startsAt)}`
            : '';

    return (
        <>
            <Snackbar
                open={Boolean(statusMessage) && dismissedStatus !== statusKey}
                onClose={() => setDismissedStatus(statusKey)}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <Alert
                    severity="warning"
                    variant="filled"
                    onClose={() => setDismissedStatus(statusKey)}
                >
                    {statusMessage}
                </Alert>
            </Snackbar>
            <Snackbar
                open={Boolean(lockedMessage)}
                autoHideDuration={6000}
                onClose={() => setLockedMessage('')}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            >
                <Alert
                    severity="warning"
                    variant="filled"
                    onClose={() => setLockedMessage('')}
                >
                    {lockedMessage}
                </Alert>
            </Snackbar>
        </>
    );
}
